import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { UserRoleEnum } from 'src/app/common/services/auth/enums/user-role.enum';
import { StorageService } from 'src/app/common/services/storage/storage.service';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { GetClientRequest, GetClientsResponse } from '../models/client.model';
import { ClientService } from '../service/client.service';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
})
export class ClientListComponent {
  @Input() filter!: GetClientRequest;

  clientList: GetClientsResponse[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  totalPages: number = 0;
  isLoading: boolean = false;
  hasSupervisorRole: boolean = false;

  ButtonColorEnum = ButtonColorEnum;

  constructor(
    private readonly clientService: ClientService,
    private readonly storageService: StorageService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const role = this.storageService.getRole();
    this.hasSupervisorRole = role === UserRoleEnum.supervisor;

    const currentPage = this.storageService.getCurrentPage();

    this.filter = {} as GetClientRequest;
    this.filter.pageNumber = parseInt(currentPage);
    this.page = parseInt(currentPage);
    this.get();
  }

  ngOnChanges() {
    if (this.filter) {
      this.resetPage();
      this.get();
    }
  }

  resetPage() {
    this.page = 1;
  }

  get() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.clearItems();

    const filters = JSON.parse(JSON.stringify(this.filter));

    filters.pageNumber = this.page;
    filters.pageSize = this.pageSize;

    this.clientService
      .get(filters)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (data) => {
          this.totalPages = data.totalPages;
          this.totalItems = data.totalItems;
          this.setClientList(data.items);
        },
        error: () => {
          this.clearItems();
        },
      });
  }

  setClientList(data: GetClientsResponse[]) {
    if (!data?.length) return;

    this.clientList = data.map((form) => ({
      id: form.id,
      name: form.name,
      active: form.active,
      cnpj: form.cnpj,
      creationDate: form.creationDate,
      skills: form.skills,
      holdingLineTime: form.holdingLineTime,
      readinessTimeExceeded: form.readinessTimeExceeded,
      returnTimeExceeded: form.returnTimeExceeded,
      minimumCallTime: form.minimumCallTime,
      shifts: form.shifts,
    }));
  }

  handleSelectPage(index: number) {
    this.page = index;
    this.clearItems();
    this.get();
    this.storageService.setCurrentPage(index.toString());
  }

  clearItems() {
    this.clientList = [];
  }

  navigateToNewForm() {
    this.router.navigate(['/client/new']);
  }
}
